import HotelLocation from './HotelLocation';
export default HotelLocation;